export default __webpack_public_path__ + "static/media/ev-on.2fc09da9.png";